// extracted by mini-css-extract-plugin
module.exports = {"root":"Students_root__2u0ul","top":"Students_top__CBXXI","details":"Students_details__OIBa5","row":"Students_row__1e8N0","students":"Students_students__1FCOg"};